export default "__VITE_ASSET__pTwaMnCu__"